import React from 'react';
import { twMerge } from 'tailwind-merge';

import { t } from '@/chassis/ui/i18n/i18n-helper';
import { i18n as sharedI18n } from '@/chassis/ui/i18n/i18n-commons';
import { useLanguage } from '@/chassis/ui/i18n/useLanguage';

interface RequiredBadgeProps {
    className?: string;
}

const RequiredBadge: React.FC<RequiredBadgeProps> = ({ className }) => (
    <BadgeContent className={className} />
);

function BadgeContent({ className }: RequiredBadgeProps) {
    const lang = useLanguage();
    const label = t(sharedI18n, 'common.labels.required', lang);

    return (
        <span
            className={twMerge([
                'rounded border border-amber-200 bg-amber-50 px-1 py-0 text-[8px] leading-none font-medium uppercase tracking-wide text-amber-600',
                className,
            ])}
        >
            {label}
        </span>
    );
}

export default RequiredBadge;
